import { useIntl } from 'react-intl'
import cruiseGlossaryMessages from 'hooks/Cruise/cruiseGlossaryMessages'
import { CruiseType } from 'constants/cruise'
import { useQsQueryParams } from 'hooks/useQueryParams'

export default function useCruiseSelectedCabinType(cruiseType?: App.CruiseType) {
  const intl = useIntl()
  const { cabinTypes } = useQsQueryParams<{ cabinTypes?: string }>()

  if (cabinTypes && cabinTypes.length > 1 && cabinTypes.includes('Oceanview') && cabinTypes.includes('Window')) {
    if (cruiseType && cruiseType === CruiseType.RIVER) {
      return intl.formatMessage(cruiseGlossaryMessages.cabinWindow)
    } else if (cruiseType && cruiseType === CruiseType.OCEAN) {
      return intl.formatMessage(cruiseGlossaryMessages.cabinOceanview)
    }

    return intl.formatMessage(cruiseGlossaryMessages.oceanviewOrWindow)
  }

  return cabinTypes
}
